// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.skitterbook-maker-container {
    height: 100%;
    background-color: var(--transparent-back-navy);
}

div.top-container {
    padding: 1rem;
}

div.bottom-container {
    padding: 1rem;
}

div.video-clip-maker-container {
    width: 100%;
    background-color: var(--muted-blue-grey2);
    border-radius: 1rem;    
    padding: 1rem;
}

div.skitterbook-live-print-container {
    width: 100%;
    background-color: var(--muted-blue-grey2);
    border-radius: 1rem;
    padding: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookMaker.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":["@import '../../css/App.css';\r\n\r\ndiv.skitterbook-maker-container {\r\n    height: 100%;\r\n    background-color: var(--transparent-back-navy);\r\n}\r\n\r\ndiv.top-container {\r\n    padding: 1rem;\r\n}\r\n\r\ndiv.bottom-container {\r\n    padding: 1rem;\r\n}\r\n\r\ndiv.video-clip-maker-container {\r\n    width: 100%;\r\n    background-color: var(--muted-blue-grey2);\r\n    border-radius: 1rem;    \r\n    padding: 1rem;\r\n}\r\n\r\ndiv.skitterbook-live-print-container {\r\n    width: 100%;\r\n    background-color: var(--muted-blue-grey2);\r\n    border-radius: 1rem;\r\n    padding: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
